var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMapPin = function SvgMapPin(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    "data-width-72": 52,
    viewBox: "0 0 17.5 20.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.53 3.479A7.42 7.42 0 0 1 8.7 1.4a7.42 7.42 0 0 1 5.17 2.079A6.96 6.96 0 0 1 16 8.473c0 2.733-1.827 5.367-3.801 7.392A26 26 0 0 1 8.7 18.85a26.082 26.082 0 0 1-3.499-2.987C3.227 13.84 1.4 11.207 1.4 8.474c0-1.87.764-3.666 2.13-4.994m4.79 16.808.38-.587za.7.7 0 0 0 .76 0L8.7 19.7c.38.588.38.587.381.587l.002-.001.006-.004.02-.013a9 9 0 0 0 .337-.23 27.474 27.474 0 0 0 3.755-3.196c2.026-2.079 4.199-5.058 4.199-8.37 0-2.254-.922-4.411-2.555-5.998A8.82 8.82 0 0 0 8.7 0a8.82 8.82 0 0 0-6.145 2.475A8.36 8.36 0 0 0 0 8.473c0 3.311 2.173 6.291 4.199 8.37a27.5 27.5 0 0 0 4.02 3.378l.072.048.02.013.006.004h.001zM6.4 8.2a2.3 2.3 0 1 1 4.6 0 2.3 2.3 0 0 1-4.6 0m2.3-3.7a3.7 3.7 0 1 0 0 7.4 3.7 3.7 0 0 0 0-7.4",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMapPin);
export default ForwardRef;